import TemplatesSection from '@modules/BillOfMaterials/Components/BillOfMaterials/TemplatesSection/TemplatesSection';
import TemplatesQuestionsSection from '@shared/Features/FAQSection/FAQSection';
import css from './TemplatesView.module.css';
import React, { useEffect, useState } from 'react';
import FAQSection from '@shared/Features/FAQSection/FAQSection';
import { notifyErrorCustom } from '@shared/Widgets/ToastNotifications/ToastNotifications';
import { useTemplatesViewModel } from '@viewModels/TemplatesViewModel/TemplatesViewModel';
import { BasicLoader } from '@shared/Ui/Loaders/BasicLoader/BasicLoader';

const TemplatesView: React.FC = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { fetchAllCategories } = useTemplatesViewModel();

    const fetchTemplates = async () => {
        setIsLoading(true);
        const projectsResponse = await fetchAllCategories();
        if (projectsResponse.error) {
            notifyErrorCustom(`${projectsResponse.message}`);
            setIsLoading(false);
            return;
        }
        setIsLoading(false);
    };

    useEffect(() => {
        fetchTemplates();
    }, []);

    if (isLoading) return <BasicLoader />;

    return (
        <section className={css.section}>
            <div className={css.header}>Bill of Materials Templates</div>
            <TemplatesSection />
            <FAQSection />
        </section>
    );
};

export default TemplatesView;
